import React from 'react';
import { View, Image, Text, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

const CardIconTitle = (props) => {

    return (
        <View style={[styles.containerStyle, props.containerStyle]}>

            {

            }

            <Image
                source={props.iconSource}
                style={[styles.imageStyle, props.imageStyle]}
                resizeMode={'contain'}
            />

            <Text style={[styles.titleStyle, props.titleStyle]}>
                {props.title}
            </Text>

        </View>
    )
};

const styles = StyleSheet.create({
    containerStyle: {
        flexDirection: 'row',
    },
    imageStyle: {
        width: 25,
        height: 25
    },
    titleStyle: {
        fontSize: 14,
    }
});

CardIconTitle.propTypes = {
    haveIcon: PropTypes.bool.isRequired,
    iconSource: PropTypes.object,

    title: PropTypes.string.isRequired,

    containerStyle: PropTypes.object,
    imageStyle: PropTypes.object,
    titleStyle: PropTypes.object
};

export { CardIconTitle };
